module.exports = "<input class=\"input input_number js-input\" type=text> <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_num\"><use xlink:href=#icon-num /> </svg> </div> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/numberEditor.hbs
// module id = 691
// module chunks = 0